import {Int, positive, Schema} from 'effect/Schema';

export const TransactionId = Int.pipe(positive()) as unknown as Schema<TransactionId>;
export type TransactionId = import('../src/TransactionId').TransactionId;
